export class RedirectOCRRequestViewModel {

  public transactionReference: string;
  public transactionStatus: string;
  public errorCode: string;
  public customerInternalReference: string;

}
